import EventManager from "../../../../manager/event_manager";
import TextureManager from "../../../../manager/texture_manager";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import ModuleManager from "../../../../framework/core/module_manager";
import Shop from "../shop/shop";
import Utility from "../../../../utility/utility";

const { ccclass, property } = cc._decorator;

@ccclass
export default class BagItem extends cc.Component{
    @property(cc.Sprite)
    itemIcon:cc.Sprite = null

    @property(cc.Label)
    itemName:cc.Label = null

    @property(cc.Sprite)
    itemLabaIcon:cc.Sprite = null

    @property(cc.Label)
    itemLabaName:cc.Label = null

    @property(cc.Label)
    countLab:cc.Label = null

    @property(cc.Node)
    countBgNode:cc.Node = null

    @property(cc.Label)
    useCount:cc.Label = null

    @property(SpriteFrameHolder)
    iconSprHolder:SpriteFrameHolder = null

    @property(cc.Node)
    goShop:cc.Node = null

    @property(cc.Node)
    infoNode:cc.Node = null

    @property(cc.Node)
    buyBtnNode:cc.Node = null


    itemData = null

    onLoad(){
        this.node.on('click', this.useItemEvent, this)
        this.goShop.on('click', function(){
            Utility.playButtonSound();
            ModuleManager.instance.showModule<Shop>(Shop, {tag: "tag_daoju"})
        }, this)
    }

    showItemInfo(data){
        let self = this
        this.itemData = data
        if (this.itemData == null){
            this.node.active = false
            return 
        }
        this.node.active = true
        if (this.itemData.isGoShop){
            this.goShop.active = true
            this.infoNode.active = false
            return
        }
        this.goShop.active = false
        this.infoNode.active = true
        this.countLab.string = data.itemNum
        this.countBgNode.active = data.itemNum > 0
        self.itemIcon.spriteFrame = this.iconSprHolder.getSpriteFrameByKey(data.itemCode)
        this.useCount.string = ""
        if (data.itemCode == "Item_Horn" || this.itemData.itemCode == "LABA_ITEM"){
            this.buyBtnNode.active = false
            this.itemIcon.node.active = false
            this.itemLabaIcon.node.active = true
            this.itemLabaIcon.spriteFrame = this.iconSprHolder.getSpriteFrameByKey(data.itemCode)
            this.itemName.string = ""
            this.itemLabaName.string = data.itemName
        }
        else{
            this.buyBtnNode.active = true
            this.itemIcon.node.active = true
            this.itemLabaIcon.node.active = false
            this.itemLabaName.string = ""
            this.itemName.string = data.itemName
            self.itemIcon.spriteFrame = this.iconSprHolder.getSpriteFrameByKey(data.itemCode)

        }
    }

    useItemEvent(){
        Utility.playButtonSound();
        if (this.itemData == null || this.itemData.itemCode == "Item_Horn" || this.itemData.itemCode == "LABA_ITEM"){
            return 
        }
        EventManager.instance.dispatch('click_use_item', this.itemData.itemId, 1)
    }

}